/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const CircleDeleteSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#E37879" />
    <path
      d="M5.8 4.8C5.91046 4.8 6 4.71046 6 4.6V4.2C6 4.08954 6.08954 4 6.2 4H9.8C9.91046 4 10 4.08954 10 4.2V4.6C10 4.71046 10.0895 4.8 10.2 4.8H11.8C11.9105 4.8 12 4.88954 12 5V5.4C12 5.51046 11.9105 5.6 11.8 5.6H11.4C11.2895 5.6 11.2 5.68954 11.2 5.8V11.6C11.2 11.7061 11.1579 11.8078 11.0828 11.8828C11.0078 11.9579 10.9061 12 10.8 12H5.2C5.09391 12 4.99217 11.9579 4.91716 11.8828C4.84214 11.8078 4.8 11.7061 4.8 11.6V5.8C4.8 5.68954 4.71046 5.6 4.6 5.6H4.2C4.08954 5.6 4 5.51046 4 5.4V5C4 4.88954 4.08954 4.8 4.2 4.8H5.8ZM5.8 5.6C5.68954 5.6 5.6 5.68954 5.6 5.8V11C5.6 11.1105 5.68954 11.2 5.8 11.2H10.2C10.3105 11.2 10.4 11.1105 10.4 11V5.8C10.4 5.68954 10.3105 5.6 10.2 5.6H5.8ZM6.8 7C6.8 6.88954 6.88954 6.8 7 6.8H7.4C7.51046 6.8 7.6 6.88954 7.6 7V9.8C7.6 9.91046 7.51046 10 7.4 10H7C6.88954 10 6.8 9.91046 6.8 9.8V7ZM8.4 7C8.4 6.88954 8.48954 6.8 8.6 6.8H9C9.11046 6.8 9.2 6.88954 9.2 7V9.8C9.2 9.91046 9.11046 10 9 10H8.6C8.48954 10 8.4 9.91046 8.4 9.8V7Z"
      fill="white"
    />
  </svg>
)

const CircleDeleteDisabledSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="8"
      cy="8"
      r="7.8"
      fill="#F9F9F9"
      stroke="#C4C4C4"
      strokeWidth="0.4"
    />
    <path
      d="M6 4.8V4H10V4.8H12V5.6H11.2V11.6C11.2 11.7061 11.1579 11.8078 11.0828 11.8828C11.0078 11.9579 10.9061 12 10.8 12H5.2C5.09391 12 4.99217 11.9579 4.91716 11.8828C4.84214 11.8078 4.8 11.7061 4.8 11.6V5.6H4V4.8H6ZM5.6 5.6V11.2H10.4V5.6H5.6ZM6.8 6.8H7.6V10H6.8V6.8ZM8.4 6.8H9.2V10H8.4V6.8Z"
      fill="#C4C4C4"
    />
  </svg>
)

const CircleDeleteIcon = (props) => {
  if (props.disabled) {
    return <Icon component={CircleDeleteDisabledSvg} {...props} />
  }
  return <Icon component={CircleDeleteSvg} {...props} />
}

export { CircleDeleteIcon }
